import { AnswerStatuses, IMeeting, IMeetingConfirmation, setClass, useViewModel } from '@utils';
import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';
import { MeetingViewModel } from '../../calendar';
import { CommonMeeting, OfferedTime } from '../../meeting';

interface ColProps {
  hours: number[];
  meetings?: IMeeting[];
  memberId?: number;
  confirmation?: IMeetingConfirmation;
  selectedMeeting?: IMeeting;
}

/**
 * @hours массив часов, начиная от startHour до 23
 * @meetings массив встреч юзера
 * @selectedRoom выбран ли КФЗ. PS: проверить нужен ли этот пропс, такое чувство, что он пришел из обычного календаря
 * @memberId ID участника. Если значение не передается, то это первая колонка с часами или последняя колонка с "+"
 * @confirmation предложенное время от участника для выбранной встречи
 * @selectedMeeting редактируемая встреча
 */
export const Col: FC<ColProps> = observer(({ memberId, meetings, hours, confirmation, selectedMeeting }) => {
  const meetingViewModel = useViewModel(MeetingViewModel);

  return (
    <div className={`col${setClass(!memberId && ' time')}`}>
      {memberId && (
        <div className="meeting-list">
          {meetings?.map((meeting) => (
            <CommonMeeting
              key={meeting.startDate.getTime() + meeting.id}
              meeting={meeting}
              startHour={hours[0]}
              setPopupCoordinates={meetingViewModel.setPopupCoordinates}
              setMoreMeetingInformation={meetingViewModel.setMoreMeetingInformation}
            />
          ))}
          {confirmation?.answerStatus === AnswerStatuses.COUNTER_OFFER && <OfferedTime
            confirmation={confirmation}
            meeting={selectedMeeting}
          />}
        </div>
      )}
      {hours.map((hour) => (
        <div
          key={`day-${hour}-${memberId ?? 'time'}`}
          className={`day${setClass(!memberId && ' time')}`}
        >
          <div className="hours">
            {!memberId && (hour < 10 ? `0${hour}:00` : `${hour}:00`)}
          </div>
        </div>
      ))}
    </div>
  );
});